import UserSwitcher from './UserSwitcher';

export default UserSwitcher;